/*
 * Real-time header cart bubble.
 * Re-renders #cart-icon-bubble on ANY cart mutation, no matter which UI/JS added
 * the item (Dawn product-form, quick-add, or a custom section). Uses the Section
 * Rendering API, plus Dawn's pub/sub cartUpdate event when available.
 */
(function () {
  var originalFetch = window.fetch;
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function refreshCartBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    originalFetch(root + '?sections=cart-icon-bubble', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        if (!html) return;
        var section = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section');
        var target = document.getElementById('cart-icon-bubble');
        if (section && target) target.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  // Intercept cart mutations regardless of caller, then refresh the bubble.
  if (typeof window.fetch === 'function') {
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) || input || '';
      var promise = originalFetch.apply(this, arguments);
      if (typeof url === 'string' && CART_MUTATION.test(url)) {
        promise
          .then(function () {
            setTimeout(refreshCartBubble, 60);
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  // Also react to Dawn's internal cart updates (bonus; cart-page changes also hit
  // /cart/change and are caught by the fetch interceptor above).
  document.addEventListener('DOMContentLoaded', function () {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartBubble);
    }
  });
})();
